export const RSVP_MESSAGES: { [id: string]: string } = {
  "Cheok Seng Lee": "Honestly Cheok, we ain't even surprised.",
  others: `Excellent! Your decision to RSVP ‘yes’ is both commendable and... dare I say, expected.
  We shall await you with great anticipation.`,
};
